import React from "react";
import {
  Grid,
  createStyles,
  makeStyles,
  Theme,
  Typography,
  Container,
  Box,
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

interface IPopularPriceProps {}

const PopularPrice: React.FC<IPopularPriceProps> = () => {
  const classes = useStyles();

  return (
    <Container className={classes.container}>
      <Grid container justify="center">
        <Grid item className={classes.popularCard} md={3}>
          <Typography className={classes.popular}>Popular</Typography>
          <Box display="flex" alignItems="center">
            <Typography className={classes.price}>€8</Typography>
            <Typography className={classes.popular}>/Month</Typography>
          </Box>
          <Typography className={classes.popularText}>
            For users that
          </Typography>
          <Box mt={5} mb={5}>
            <Typography className={classes.popularText}>Base plus</Typography>
            <Grid
              container
              justify="flex-start"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <CheckCircleIcon className={classes.iconWhite} />
              </Grid>
              <Grid item>
                <Typography className={classes.popularText}>
                  Connect knowledge hubs
                </Typography>
                <img src="images/sources_logos.png" alt="sources" />
              </Grid>
            </Grid>
            <Grid
              container
              justify="flex-start"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <CheckCircleIcon className={classes.iconWhite} />
              </Grid>
              <Grid item>
                <Typography className={classes.popularText}>
                  AI to summarize findings
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justify="flex-start"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <CheckCircleIcon className={classes.iconWhite} />
              </Grid>
              <Grid item>
                <Typography className={classes.popularText}>
                  Collaboration
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justify="flex-start"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <CheckCircleIcon className={classes.iconWhite} />
              </Grid>
              <Grid item>
                <Typography className={classes.popularText}>
                  Cross-referencing
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <Grid item className={classes.demoButton}>
            <Typography className={classes.demoButtonText}>
              Talk soon!
            </Typography>
          </Grid>
        </Grid>
        <Grid item md={5} className={classes.containerCard}>
          <Typography className={classes.title}>
            Thank you very much for your interest!
          </Typography>
          <Typography className={classes.text}>
            faktual received your request and will get back to you soon.{" "}
          </Typography>
          <Typography className={classes.text}>
            Until then we hope you enjoy faktual for free.
          </Typography>
          <Typography className={classes.text}>Keep it up! </Typography>
        </Grid>
      </Grid>
    </Container>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginTop: "100px",
      height: "100%",
    },
    containerCard: {
      background: "linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%)",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      borderTopRightRadius: "10px",
      borderBottomRightRadius: "10px",
      padding: theme.spacing(5),
    },
    popularCard: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: theme.palette.primary.main,
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "10px",
      borderBottomLeftRadius: "10px",
      padding: theme.spacing(2),
    },
    demoButton: {
      backgroundColor: "#9BCE63",
      border: "2px solid #9BCE63",
      boxSizing: "border-box",
      borderRadius: "10px",
      height: "56px",
      padding: theme.spacing(2),
      textAlign: "center",
      filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
    },
    demoButtonText: {
      fontSize: "20px",
      lineHeight: "23px",
      color: "#FFFFFF",
      fontWeight: "bold",
    },
    title: {
      fontSize: "20px",
      lineHeight: "23px",
      marginBottom: theme.spacing(4),
    },
    text: {
      fontSize: "15px",
      lineHeight: "18px",
      marginBottom: theme.spacing(4),
    },
    iconWhite: {
      fontSize: "15px",
      color: "#FFF",
    },
    iconBlue: {
      fontSize: "15px",
      color: theme.palette.primary.main,
    },
    popular: {
      fontSize: "20px",
      lineHeight: "23px",
      color: "#FFFFFF",
    },
    price: {
      fontSize: "50px",
      lineHeight: "59px",
      fontWeight: "bold",
      color: "#FFFFFF",
      marginRight: theme.spacing(2),
    },
    popularText: {
      color: "#FFFFFF",
    },
  })
);

export default PopularPrice;
